// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SiteAdmin-FormDefinitionConfig-SelectableFormFields-module-clickAwayLayer {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 1;
}

.SiteAdmin-FormDefinitionConfig-SelectableFormFields-module-deleteIcon {
	color: var(--Red300);
}

.SiteAdmin-FormDefinitionConfig-SelectableFormFields-module-drawerNodeContainer {
	background-color: var(--PrimaryWhite);
}

.SiteAdmin-FormDefinitionConfig-SelectableFormFields-module-drawerNodeContainerLeft, .SiteAdmin-FormDefinitionConfig-SelectableFormFields-module-drawerNodeContainerRight {
	overflow-y: scroll;
}

.SiteAdmin-FormDefinitionConfig-SelectableFormFields-module-drawerNodeContainerLeft {
	border-right: var(--StandardBorder);
}

.SiteAdmin-FormDefinitionConfig-SelectableFormFields-module-drawerNodeContainerRight {
	border-left: var(--StandardBorder);
}

.SiteAdmin-FormDefinitionConfig-SelectableFormFields-module-flexUniversalDrawerMainContentContainer {
	position: relative;
}

.SiteAdmin-FormDefinitionConfig-SelectableFormFields-module-flexUniversalDrawerMiddleContainer {
	min-width: 1024px;
}

.SiteAdmin-FormDefinitionConfig-SelectableFormFields-module-flexUniversalDrawerRootContainer {
	overflow-x: scroll;
	overflow-y: hidden;
	position: relative;
}

.SiteAdmin-FormDefinitionConfig-SelectableFormFields-module-iconButtonWhiteBackground {
	color: var(--PrimaryWhite);
}

.SiteAdmin-FormDefinitionConfig-SelectableFormFields-module-selectableComponent {
	border-radius: 4px;
	margin: 2px;
	padding: 2px;
}

.SiteAdmin-FormDefinitionConfig-SelectableFormFields-module-selectableFormFieldsContainer {
	border: var(--StandardBorder);
	height: 100%;
}

.SiteAdmin-FormDefinitionConfig-SelectableFormFields-module-selectedTooltip {
	background-color: var(--Black400);
	border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/SiteAdmin/FormDefinitionConfig/SelectableFormFields.module.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;CACT,UAAU;AACX;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;AACb;;AAEA;CACC,6BAA6B;CAC7B,YAAY;AACb;;AAEA;CACC,iCAAiC;CACjC,kBAAkB;AACnB","sourcesContent":[".clickAwayLayer {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tz-index: 1;\n}\n\n.deleteIcon {\n\tcolor: var(--Red300);\n}\n\n.drawerNodeContainer {\n\tbackground-color: var(--PrimaryWhite);\n}\n\n.drawerNodeContainerLeft, .drawerNodeContainerRight {\n\toverflow-y: scroll;\n}\n\n.drawerNodeContainerLeft {\n\tborder-right: var(--StandardBorder);\n}\n\n.drawerNodeContainerRight {\n\tborder-left: var(--StandardBorder);\n}\n\n.flexUniversalDrawerMainContentContainer {\n\tposition: relative;\n}\n\n.flexUniversalDrawerMiddleContainer {\n\tmin-width: 1024px;\n}\n\n.flexUniversalDrawerRootContainer {\n\toverflow-x: scroll;\n\toverflow-y: hidden;\n\tposition: relative;\n}\n\n.iconButtonWhiteBackground {\n\tcolor: var(--PrimaryWhite);\n}\n\n.selectableComponent {\n\tborder-radius: 4px;\n\tmargin: 2px;\n\tpadding: 2px;\n}\n\n.selectableFormFieldsContainer {\n\tborder: var(--StandardBorder);\n\theight: 100%;\n}\n\n.selectedTooltip {\n\tbackground-color: var(--Black400);\n\tborder-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"clickAwayLayer": `SiteAdmin-FormDefinitionConfig-SelectableFormFields-module-clickAwayLayer`,
	"deleteIcon": `SiteAdmin-FormDefinitionConfig-SelectableFormFields-module-deleteIcon`,
	"drawerNodeContainer": `SiteAdmin-FormDefinitionConfig-SelectableFormFields-module-drawerNodeContainer`,
	"drawerNodeContainerLeft": `SiteAdmin-FormDefinitionConfig-SelectableFormFields-module-drawerNodeContainerLeft`,
	"drawerNodeContainerRight": `SiteAdmin-FormDefinitionConfig-SelectableFormFields-module-drawerNodeContainerRight`,
	"flexUniversalDrawerMainContentContainer": `SiteAdmin-FormDefinitionConfig-SelectableFormFields-module-flexUniversalDrawerMainContentContainer`,
	"flexUniversalDrawerMiddleContainer": `SiteAdmin-FormDefinitionConfig-SelectableFormFields-module-flexUniversalDrawerMiddleContainer`,
	"flexUniversalDrawerRootContainer": `SiteAdmin-FormDefinitionConfig-SelectableFormFields-module-flexUniversalDrawerRootContainer`,
	"iconButtonWhiteBackground": `SiteAdmin-FormDefinitionConfig-SelectableFormFields-module-iconButtonWhiteBackground`,
	"selectableComponent": `SiteAdmin-FormDefinitionConfig-SelectableFormFields-module-selectableComponent`,
	"selectableFormFieldsContainer": `SiteAdmin-FormDefinitionConfig-SelectableFormFields-module-selectableFormFieldsContainer`,
	"selectedTooltip": `SiteAdmin-FormDefinitionConfig-SelectableFormFields-module-selectedTooltip`
};
module.exports = ___CSS_LOADER_EXPORT___;
